type DrawIndividualConfettiParams = {
  ctx: CanvasRenderingContext2D | null;
  canvas: {
    width: number;
    height: number;
  };
  colors: string[];
};

const drawIndividualConfetti = ({ ctx, colors, canvas }: DrawIndividualConfettiParams): void => {
  if (ctx) {
    ctx.save();
    ctx.fillStyle = colors[Math.floor(Math.random() * colors.length)];
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
  }
};

export default drawIndividualConfetti;
